import {
	ADMIN_BAN_IP_FORM_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'
import adminBanIpUser from 'root/src/client/logic/banIp/thunks/adminBanIpUser'
import adminUnbanIpUser from 'root/src/client/logic/banIp/thunks/adminUnbanIpUser'

export default {
	[ADMIN_BAN_IP_FORM_MODULE_ID]: [
		{
			action: adminBanIpUser,
		},
		{
			action: adminUnbanIpUser,
		},
	],
}
